var keys = {
    NAV_whatsappAccounts: "NAV_whatsappAccounts",
    NAV_partners: "NAV_partners",
    NAV_integrations: "NAV_integrations",
    NAV_support: "NAV_support",
    NAV_profile: "NAV_profile",
    NAV_billing: "NAV_billing",
    NAV_helpAndFeedback: "NAV_helpAndFeedback",
    NAV_preferences: "NAV_preferences",
    NAV_signOut: "NAV_signOut",
    NAV_dock: "NAV_dock",
    NAV_undock: "NAV_undock",
    NAV_templateBilling: "NAV_templateBilling",
    NAV_conversationBilling: "NAV_conversationBilling",
    NAV_billingText: "NAV_billingText",
    NAV_insights: "NAV_insights",
    NAV_insightsAndBilling: "NAV_insightsAndBilling",
    NAV_organizationSettings: "NAV_organizationSettings",
    NAV_connectedApps: "NAV_connectedApps",
    NAV_notifications: "NAV_notifications",
    NAV_logout: "NAV_logout",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImtleXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTSxJQUFJLEdBQTRCO0lBQ3BDLG9CQUFvQixFQUFFLHNCQUFzQjtJQUM1QyxZQUFZLEVBQUUsY0FBYztJQUM1QixnQkFBZ0IsRUFBRSxrQkFBa0I7SUFDcEMsV0FBVyxFQUFFLGFBQWE7SUFDMUIsV0FBVyxFQUFFLGFBQWE7SUFDMUIsV0FBVyxFQUFFLGFBQWE7SUFDMUIsbUJBQW1CLEVBQUUscUJBQXFCO0lBQzFDLGVBQWUsRUFBRSxpQkFBaUI7SUFDbEMsV0FBVyxFQUFFLGFBQWE7SUFDMUIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsVUFBVSxFQUFFLFlBQVk7SUFDeEIsbUJBQW1CLEVBQUUscUJBQXFCO0lBQzFDLHVCQUF1QixFQUFFLHlCQUF5QjtJQUNsRCxlQUFlLEVBQUUsaUJBQWlCO0lBQ2xDLFlBQVksRUFBRSxjQUFjO0lBQzVCLHNCQUFzQixFQUFFLHdCQUF3QjtJQUNoRCx3QkFBd0IsRUFBRSwwQkFBMEI7SUFDcEQsaUJBQWlCLEVBQUUsbUJBQW1CO0lBQ3RDLGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxVQUFVLEVBQUUsWUFBWTtDQUN6QixDQUFDO0FBRUYsZUFBZSxJQUFJLENBQUMifQ==